import { useEffect } from 'react';

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/** 手機友善的二次確認 — 明確「取消 / 确定」按鈕,比 window.confirm 不易誤觸 */
export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = '确定',
  cancelLabel = '取消',
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onCancel(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onCancel]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center p-4 sm:p-6" role="dialog" aria-modal="true" aria-labelledby="confirm-title">
      <button type="button" className="absolute inset-0 bg-black/45 cursor-default" aria-label="关闭" onClick={onCancel} />
      <div className="relative w-full max-w-md rounded-2xl bg-background-50 border border-secondary-200 shadow-xl p-5 sm:p-6 animate-in">
        <h2 id="confirm-title" className="text-base sm:text-lg font-semibold text-foreground-950 mb-2">{title}</h2>
        <p className="text-[15px] sm:text-sm text-foreground-700 leading-relaxed whitespace-pre-wrap">{message}</p>
        <div className="mt-5 flex flex-col-reverse sm:flex-row gap-2.5 sm:justify-end">
          <button
            type="button"
            onClick={onCancel}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-1.5 px-5 py-3 rounded-xl text-[15px] sm:text-sm font-semibold border-2 border-secondary-300 text-foreground-700 bg-background-100 hover:bg-secondary-50 cursor-pointer"
          >
            <i className="ri-close-line"></i>{cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-1.5 px-5 py-3 rounded-xl text-[15px] sm:text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 cursor-pointer"
          >
            <i className="ri-check-line"></i>{confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
